<template>
	<div class="checkout-order-blocker" v-if="blockOrderCheckout">
		<div class="checkout-order-blocker-title">{{ titleText }}</div>
		<div class="checkout-order-blocker-subtitle">
			{{ subtitleText }}
		</div>
		<button class="button button-primary" @click="goToMenu">
			Return to Menu
		</button>
	</div>
</template>

<style scoped>
.checkout-order-blocker {
	position: absolute;
	width: 100%;
	height: 100%;
	z-index: 1000;
	background: var(--gR-base-90-backdrop-dark);
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.checkout-order-blocker .checkout-order-blocker-title {
	font-size: 18px;
	font-weight: 600;
	margin-bottom: 14px;
}

.checkout-order-blocker .checkout-order-blocker-subtitle {
	margin-bottom: 30px;
	font-size: 14px;
}

.checkout-order-blocker > div {
	color: var(--gR-white);
}

.checkout-order-blocker .button {
	width: auto;
	padding: 0 42px;
}

@media only screen and (max-width: 900px) {
	.checkout-order-blocker {
		position: fixed;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
	}
}
</style>

<script>
import currencyFilterMixin from "@/mixins/currency-filter-mixin"

export default {
	name: "CheckoutOrderBlocker",
	mixins: [currencyFilterMixin],
	computed: {
		blockOrderCheckout() {
			return this.cartMinimumNotMet || this.requireFoodProducts
		},
		cartMinimumNotMet() {
			const price = this.$store.getters.price
			const min_amount = this.$store.getters.minimumOrderAmount
			if (price < min_amount && this.$store.state.sessionOrderLoaded) {
				return (
					price < min_amount ||
					this.$store.getters.itemsInCartCount < 1
				)
			}
		},
		requireFoodProducts() {
			if (this.$store.state.sessionOrderLoaded) {
				return this.$store.getters.cartHasOnlyAlcohol
			}
		},
		titleText() {
			if (this.cartMinimumNotMet) {
				return "Add More To Cart"
			} else if (this.requireFoodProducts) {
				return "Add Food to Cart"
			}
			return ""
		},
		subtitleText() {
			if (this.cartMinimumNotMet) {
				return `Order minimum of ${this.$options.filters.currency(
					this.$store.getters.minimumOrderAmount
				)} not met`
			} else if (this.requireFoodProducts) {
				return "Orders containg alcohol must have food"
			}
			return ""
		}
	},
	methods: {
		goToMenu() {
			if (this.cartMinimumNotMet) {
				this.$store.dispatch("sendMixpanelEvent", {
					msg: "App Minimum Alert Clicked"
				})
			} else if (this.requireFoodProducts) {
				this.$store.dispatch("sendMixpanelEvent", {
					msg: "Alcohol Only Alert Clicked"
				})
			}
			const routeParams = this.$route.params
			const routeMeta = this.$route.meta
			if (routeMeta.isEvent) {
				this.$router.push(
					`/${routeParams.slug}/menu/event/${routeParams.eventId}`
				)
			} else {
				this.$router.push(`/${routeParams.slug}/menu`)
			}
		}
	}
}
</script>
